export default {"src":"/_next/static/media/home.f2363d36.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};